import { Type } from '@angular/core';

export class AdItem {
  constructor(public component: Type<any>, public data: any) {}
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/ad-item.ts